import { UpdateOfficeAdapters } from '../adapters';
import { addAddress } from '../clients/AddAddress';
import { updateOfficeInfo } from '../clients/UpdateOfficeInfo';
import { updateUserEducation } from '../clients/UpdateUserEducation';
import { UpdateOfficeApiError } from '../errors';
import type { IUpdateOfficeRequest } from '../types/UpdateOffice';
import type { TAddAddressApiResponse } from '../types/UpdateOffice.api';

export interface IUpdateOfficeResult {
  /** The BE echo from POST /user/address when an address call was made;
   *  null otherwise. */
  address: TAddAddressApiResponse | null;
}

const updateOffice = async (input: IUpdateOfficeRequest): Promise<IUpdateOfficeResult> => {
  try {
    await updateOfficeInfo(UpdateOfficeAdapters.toUpdateOfficeInfoPayload(input));
    let address: TAddAddressApiResponse | null = null;
    if (input.placeId) {
      try {
        address = await addAddress(UpdateOfficeAdapters.toAddAddressPayload(input.placeId));
      } catch (addressError) {
        // Address failures (e.g. BE enforces same-state rule) should paint the
        // address field — tag the typed error so the form can setError on it.
        const typed = UpdateOfficeApiError.fromAxiosError(addressError, 'officeAddress');
        throw typed ?? addressError;
      }
    }
    await updateUserEducation(UpdateOfficeAdapters.toUpdateUserEducationPayload(input));
    return { address };
  } catch (error) {
    if (error instanceof UpdateOfficeApiError) {
      throw error;
    }
    const typedError = UpdateOfficeApiError.fromAxiosError(error);
    throw typedError ?? error;
  }
};

export const UpdateOfficeService = { updateOffice };
